export const persistClosedTableOccupations = (storage, closedTableOccupations, maxEntries = 5) => {
  const items = Array.isArray(closedTableOccupations) ? closedTableOccupations : [];

  const writeEntries = (entries) => {
    storage.setItem("receipts", JSON.stringify(entries));
  };

  try {
    writeEntries(items);
    return true;
  } catch (error) {
    const isQuotaExceeded = !!(
      error && (
        error.name === "QuotaExceededError" ||
        error.name === "NS_ERROR_DOM_QUOTA_REACHED" ||
        error.code === 22 ||
        error.code === 1014
      )
    );

    if (!isQuotaExceeded) {
      throw error;
    }

    const trimmedEntries = items.slice(-maxEntries);
    if (trimmedEntries.length === items.length) {
      throw error;
    }

    writeEntries(trimmedEntries);
    return true;
  }
};

export const saveClosedTableOccupations = (closedTableOccupations, maxEntries = 5) => {
  return persistClosedTableOccupations(localStorage, closedTableOccupations, maxEntries);
};
